import { Observable } from "rxjs";
import * as http from "../../../../../../../../../services/http.service";
import { IFlyerDetailPage } from "../../../../../../../types/flyer-detail-data/flyer-detail-page/flyer-detail-page.interface";
import { map, switchMap } from "rxjs/operators";
import { IFlyerDetailPagePosition } from "../../../../../../../types/flyer-detail-data/flyer-detail-page-position/flyer-detail-page-position.interface";
import { SearchResults } from "../../../../../../../../../types/search/search-results.interface";
import { FlyerDetailPageForm } from "../types/flyer-detail-page-form.interface";

export function fetchPage(pageId: number): Observable<IFlyerDetailPage> {
  return http.get<IFlyerDetailPage>(endPoint(pageId)).pipe(
    switchMap((page) =>
      http.get<SearchResults<IFlyerDetailPagePosition>>(`/positions/?page_id=${pageId}`).pipe(
        map((searchResults) => ({
          ...page,
          positions: searchResults.results,
        }))
      )
    )
  );
}

export function savePage(id: number, changes: FlyerDetailPageForm): Observable<IFlyerDetailPage> {
  return http.patch(endPoint(id), changes);
}

function endPoint(pageId: number): string {
  return `/pages/${pageId}/`;
}
